import { ComposeViewState } from 'owa-mail-compose-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getSharingLinkInfo } from 'owa-link-data';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import AttachmentPermissionType from 'owa-service/lib/contract/AttachmentPermissionType';
import DocLink from 'owa-service/lib/contract/DocLink';

export function getDocLinks(viewState: ComposeViewState): DocLink[] {
    const docLinks: DocLink[] = [];

    if (!isFeatureEnabled('doc-attachment-contextualSharingTips')) {
        return docLinks;
    }

    viewState.attachmentWell.sharingLinkIds.forEach(id => {
        const sharingLinkInfo = getSharingLinkInfo(id);
        const attachmentPermissionType: AttachmentPermissionType = getAttachmentPermissionTypeFromAttachmentPermissionLevel(
            sharingLinkInfo.permissionLevel
        );

        if (
            attachmentPermissionType === AttachmentPermissionType.View ||
            attachmentPermissionType === AttachmentPermissionType.Edit
        ) {
            const docLink: DocLink = {
                ProviderType: 'OneDrivePro',
                Url: sharingLinkInfo.url,
                PermissionType: attachmentPermissionType,
            };
            docLinks.push(docLink);
        }
    });

    return docLinks;
}

function getAttachmentPermissionTypeFromAttachmentPermissionLevel(
    permissionLevel: AttachmentPermissionLevel
): AttachmentPermissionType {
    switch (permissionLevel) {
        case AttachmentPermissionLevel.AnonymousEdit:
            return AttachmentPermissionType.AnonymousEdit;
        case AttachmentPermissionLevel.AnonymousView:
            return AttachmentPermissionType.AnonymousView;
        case AttachmentPermissionLevel.OrganizationEdit:
            return AttachmentPermissionType.OrganizationEdit;
        case AttachmentPermissionLevel.OrganizationView:
            return AttachmentPermissionType.OrganizationView;
        case AttachmentPermissionLevel.Edit:
            return AttachmentPermissionType.Edit;
        case AttachmentPermissionLevel.View:
            return AttachmentPermissionType.View;
        default:
            return AttachmentPermissionType.None;
    }
}
